import { render } from "./DemographicsForm.vue?vue&type=template&id=3ebdf2de"
import script from "./DemographicsForm.vue?vue&type=script&lang=js"
export * from "./DemographicsForm.vue?vue&type=script&lang=js"

import "./DemographicsForm.vue?vue&type=style&index=0&id=3ebdf2de&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__